import { ASSET_DATASOURCE_IDS } from "./assetDatasourceIds";
import type { DatasourceKind } from "./visibleDatasources";

export const datasourceKindOfTab = (tab: string | undefined): DatasourceKind => {
    const datasourceId = (tab ?? "").split("/")[0];
    return (ASSET_DATASOURCE_IDS as readonly string[]).includes(datasourceId)
        ? "asset"
        : "document";
};
